import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { IconProps } from "./types";

export function CirclePlusIcon({ size, ...props }: IconProps) {
    return <AddCircleOutlineRoundedIcon fontSize={size} {...props} />;
}
